import { useQuery } from 'react-query';

import { getVersionDetails as queryFn } from 'api/endPoints/getVersionDetails';

import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

export const useQueryVersionList = (params: QueryParams) => {
    return useQuery<string[], QueryError, QueryResponse[]>({
        queryKey: ['versionList', params],
        queryFn: () => queryFn(params),
        enabled: params.hashList.length > 0,
        cacheTime: 0,
    });
};

interface QueryParams {
    hashList: string[];
}
export interface QueryResponse {
    contractId: number;
    contractName: string;
    contractUuid: ProjectTreeNode['uuid'];
    maxLevel: number;
    projectId: number;
    projectName: string;
    projectUuid: ProjectTreeNode['uuid'];
    sourceFile: string;
    versionDate: number;
    versionDbId: number;
    versionHashCode: number;
    versionName: string;
    versionUniqueId: number;
}
